import React from 'react';
import {Form, FormGroup, ControlLabel, FormControl, Button, Modal} from 'react-bootstrap';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import './styles.css';
const ReactTags = require('react-tag-autocomplete');

class AddressFormModal extends React.Component{

    static contextTypes = { api:PropTypes.object, notifier: PropTypes.object };

    constructor( props, context ){
        super(props);
        if( !props.editing ) {
            this.state = {
                form: {
                    name:'',
                    email:'',
                    mailerTags:[],
                    active: true
                }
            };
        }
        else {
            this.state = {
                form: {
                    name: props.editing.name,
                    email:props.editing.email,
                    mailerTags:props.editing.mailerTags,
                    active:props.editing.active
                }
            };
        }
        context.api.mailerTags.get( 0, 200, '@Class.MailerTags.mailerTags.get' )
    }

    handleDeleteTag = (tag) => {
        const mailerTags  = this.state.form.mailerTags.slice(0);
        mailerTags.splice(tag,1);
        this.setState({form:{...this.state.form,mailerTags: mailerTags}});
    };

    handleAdditionTag = (tag) => {
        const mailerTags = [...this.state.form.mailerTags];
        let tagExists = false;
        for(let i=0; i<mailerTags.length;i++){
            if(tag.id===undefined) { if(mailerTags[i].name===tag.name) return tagExists }
            else{if( mailerTags[i].id===tag.id) return tagExists=true; }
        }
        if(mailerTags<1 || tagExists===false) mailerTags.push(tag);
        return this.onFormChange({target:{name:'mailerTags',value:mailerTags}})
    };

    onFormChange = ({target})=>{
        this.setState( { form: { ...this.state.form, [target.name]:target.value}} );
    };

    getFormValue = ( name )=>{
        return this.state.form[name]? this.state.form[name]:'';
    };

    saveForm = ()=>{
        if( !this.state.form.name || !this.state.form.email ){
            return this.context.notifier.error('No has llenado todos los campos');
        }
        const address = { ...this.state.form };
        const finish = ()=>{
            if( this.props.didSave ) this.props.didSave();
            else if( this.props.onHide ) this.props.onHide();
        };
        if (this.props.editing) this.context.api.emailAddresses.edit(this.props.editing.id, address, '@Class.EmailAddresses.EmailAddress.edit' ).then(finish);
        else this.context.api.emailAddresses.create( address, '@Class.EmailAddresses.EmailAddress.create').then(finish);
    };

    render(){
        const { onHide } = this.props;
        return (
            <Modal
                show={true}
                onHide={ onHide }>

                <Modal.Header closeButton>
                    <Modal.Title>{this.props.editing? 'Editar contacto' : 'Añadir contacto'}</Modal.Title>
                </Modal.Header>

                <Modal.Body >
                    <Form className='AddressFormModal'>
                        <FormGroup>
                            <ControlLabel>Nombre:</ControlLabel>
                            <FormControl
                                autoFocus={true}
                                placeholder='Nombre del contacto'
                                name='name'
                                value={ this.getFormValue('name') }
                                onChange={this.onFormChange}
                                required/>
                        </FormGroup>

                        <FormGroup>
                            <ControlLabel>Dirección de correo:</ControlLabel>
                            <FormControl
                                placeholder='Correo Electrónico'
                                name='email'
                                value={ this.getFormValue('email') }
                                onChange={this.onFormChange}
                                required/>
                        </FormGroup>

                        <FormGroup>
                            <ControlLabel>Grupos de correo:</ControlLabel>
                            <ReactTags tags={this.getFormValue('mailerTags')}
                                       allowNew={true}
                                       placeholder=''
                                       suggestions={this.props.mailerTags}
                                       handleDelete={this.handleDeleteTag}
                                       handleAddition={this.handleAdditionTag}
                                       autofocus={false}/>
                        </FormGroup>

                        {/*
                        <FormGroup>
                            <ControlLabel>Activo:</ControlLabel><br/>
                            <Switch
                                name='active'
                                onChange={(value)=>this.onFormChange({target:{name:"active", value:value}})}
                                checked={!!this.getFormValue('active')}
                                id="normal-switch"/>
                        </FormGroup>
                        */}
                        <Button
                            bsStyle='danger'
                            onClick={this.props.onHide}
                            disabled={this.props.loadingIds[this.loadingId]}>Cancelar</Button>
                        <Button
                            bsStyle='success'
                            className='pull-right'
                            onClick={this.saveForm}
                            disabled={this.props.loadingIds[this.loadingId]}>Guardar</Button>
                    </Form>
                </Modal.Body>
            </Modal>
        );
    }
}

const mapStateToProps = ( { api:{mailerTags=[]}, loadingIds } )=>({mailerTags, loadingIds});

export default connect(mapStateToProps)(AddressFormModal);


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/MailManager/components/AddressFormModal/index.jsx